<template>
    <div id="data-list-list-view">
      <vs-tabs v-model="tabIndex" class="padTop20" >
        <vs-tab :label="item.name" v-for="(item,index) in vsTabsList" :key="index">
          <!-- 筛选框 -->
          <div class="filterWrap marTop18">
            <div :class="tabIndex == 2 ||tabIndex == 3?'flex btn-box mb-60':'flex btn-box'">
              <v-select v-if="tabIndex == 2" v-model="concatType" :options="concatTypeOptions" :reduce="opt => opt.id"
                        placeholder="往来类型" class="select-wrap">
                  <div slot="no-options">暂无选项</div>
              </v-select>
              <!-- <v-select multiple v-if="tabIndex == 0 || tabIndex == 2" v-model="customerType" :options="customerTypeOptions" :reduce="opt => opt.label"
                      placeholder="客户类型">
                <div slot="no-options">暂无选项</div>
              </v-select>  -->
                <v-select v-if="tabIndex == 2" style="margin-left:8px;margin-right:8px" v-model="accountType" :options="accountTypeOptions" :reduce="opt => opt.id"
                          placeholder="账户类型">
                    <div slot="no-options">暂无选项</div>
                </v-select>
               <el-select
                v-model="customerType"
                multiple
                collapse-tags
                style="width:280px;"
                class="customerType"
                placeholder="门店类型">
                <el-option
                  v-for="item in customerTypeOptions"
                  :key="item.id"
                  :label="item.label"
                  :value="item.label">
                </el-option>
                 <div slot="no-options">暂无选项</div>
              </el-select>
              <!-- <v-select style="margin-left:8px " v-model="moneyStatus" :options="moneyStatusOptions" v-if="tabIndex == 0"
                        :reduce="opt => opt.id" placeholder="账户状态" class="select-wrap">
                  <div slot="no-options">暂无选项</div>
              </v-select>  -->
              <v-select v-model="transferStatus1" :options="transferStatuOptions1" v-if="tabIndex == 3"
                        :reduce="opt => opt.id" placeholder="转账状态" class="select-wrap">
                  <div slot="no-options">暂无选项</div>
              </v-select>
              <div v-if="tabIndex > 1" class="date-wrap">
                <flat-pickr v-model="beginTime" class="filterInput"
                    :config="flatPickerConfig" placeholder="开始时间"/>
                <div>至</div>
                <flat-pickr v-model="endTime" class="filterInput"
                    :config="flatPickerConfig" placeholder="结束时间"/>
              </div>

              <gc-cmp-vs-input v-model="filterText" class="filterInput marLeft8"
                            placeholder="请输入门店名称/编码" />
              <vs-button type="filled" size="small" @click.prevent="searchData()" class="marLeft16">查询</vs-button>
            </div>


            <div :class="tabIndex == 2 ||tabIndex == 3?'flex btn-content':'flex'">
              <!-- 资金列表 -->
              <template v-if="tabIndex == 0">
                <div v-if="filtering('storeFunds:bulkRecharge')" class="flex download-wrap pointer" @click="downrechargeEvent()">
                  <vs-button class="down-btn" type="border" icon-pack="feather" icon="icon-share">批量充值</vs-button>
                </div>
                  <div v-if="filtering('storeFunds:fundDownload')" class="download-wrap marLeft20 pointer" @click.stop="download()">
                      <vs-button class="down-btn" type="border" icon-pack="feather" icon="icon-download">下载全部</vs-button>
                  </div>
              </template>
              <!-- 门店银行账号 -->
              <template v-if="tabIndex == 1">
                <vs-button v-if="filtering('storeFunds:bankAdd')" type="filled" size="small" @click.prevent="editBank1()" class="marLeft16">新增</vs-button>
                <div v-if="filtering('storeFunds:bankImport')" class="flex download-wrap marLeft20 pointer" @click="downrechargeBatch()">
                    <vs-button class="down-btn" type="border" icon-pack="feather" icon="icon-share">批量导入</vs-button>
                </div>
                  <div v-if="filtering('storeFunds:bankExport')" class="download-wrap marLeft20 pointer" @click.stop="download()">
                      <vs-button class="down-btn" type="border" icon-pack="feather" icon="icon-download">下载全部</vs-button>
                  </div>
              </template>
                <!--门店收支明细-->
                <template v-if="tabIndex == 2">
                    <div v-if="filtering('storeFunds:expenditureExport')" class="download-wrap marLeft20 pointer" @click.stop="download()">
                        <vs-button class="down-btn" type="border" icon-pack="feather" icon="icon-download">下载全部</vs-button>
                    </div>
<!--                    <vs-button type="filled" size="small" @click.prevent="editBank1()" class="marLeft16">新增</vs-button>-->
<!--                    <div class="flex download-wrap marLeft20 pointer" @click="downrechargeBatch()">-->
<!--                        <vs-button class="down-btn" type="border" icon-pack="feather" icon="icon-share">批量2导入</vs-button>-->
<!--                    </div>-->
<!--                    <div class="download-wrap marLeft20 pointer" @click.stop="download()">-->
<!--                        <vs-button class="down-btn" type="border" icon-pack="feather" icon="icon-download">下载全部</vs-button>-->
<!--                    </div>-->
                </template>
                <!--门店转账充值记录-->
                <template v-if="tabIndex == 3">
                    <div v-if="filtering('storeFunds:rechargeExport')" class="download-wrap marLeft20 pointer" @click.stop="download()">
                        <vs-button class="down-btn" type="border" icon-pack="feather" icon="icon-download">下载全部</vs-button>
                    </div>

                </template>
<!--              <div class="download-wrap marLeft20 pointer" @click.stop="download()">-->
<!--                <vs-button class="down-btn" type="border" icon-pack="feather" icon="icon-download">下载全部</vs-button>-->
<!--              </div>-->
            </div>
          </div>
          <div  class="con-tablex vs-table--content vs-con-loading__container" id="div-with-loading">
            <div class="vs-con-tbody vs-table--tbody">
              <vs-table :multiple="tabIndex == 0 ? true : false" v-model="tableselected" :data="tableData" class="vs-table vs-table--tbody-table">
                <template slot="thead" class="vs-table--thead">
                  <vs-th v-for="(column, index) in columns[tabIndex]" :key="index">
                    {{column.name}}
                  </vs-th>
                </template>
                <template slot-scope="{data}">
                  <tbody v-if="data.length > 0">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                      <!-- :class="tdItem.code == 'moneyAmount' || tdItem.code == 'afterAmount' || tdItem.code == 'changeAmount' ? 'textAlignR': ''" -->
                      <vs-td :class="tdItem.dtClass?tdItem.dtClass:''" v-for="(tdItem,tdIndex) in columns[tabIndex]" :key="tdIndex">
                        <template v-if="tdItem.code == 'index'">
                          {{indextr+1}}
                        </template>
                        <template v-if="tdItem.code == 'accountType'">
                          <span v-if="tr[tdItem.code]==0">预付款账户</span>
                          <span v-if="tr[tdItem.code]==1">达量奖励账户</span>
                          <span v-if="tr[tdItem.code]==2">门店补贴账户</span>
                          <span v-if="tr[tdItem.code]==3">返货账户</span>
                        </template>
                        <template v-else-if="tdItem.code == 'option'">
                          <div v-if="tabIndex == 0">
                            <vs-button color="primary" type="flat" class="flat-btn-table" @click.stop="openAccount(tr)">账户管理</vs-button>
                            <vs-button color="primary" type="flat" class="flat-btn-table" @click.stop="openDialog(tr)">调整资金</vs-button>
                            <!-- <vs-button v-if="tr.stats == 0" color="primary" class="flat-btn-table" type="flat"  @click.stop="closeFundAccount(tr,indextr, false)">启用资金账户</vs-button> -->
                            <!-- <vs-button v-else color="primary" type="flat" class="flat-btn-table"  @click.stop="closeFundAccount(tr,indextr, true)">关闭资金账户</vs-button> -->
                          </div>
                          <div v-if="tabIndex == 1 && !tr.newFlag">
                            <vs-button color="primary" v-if="filtering('storeFunds:bankUpdate')" type="flat" class="flat-btn-table" @click="editBank1(tr)">编辑</vs-button>
                            <vs-button color="primary" v-if="filtering('storeFunds:bankDelete')" type="flat" class="flat-btn-table" @click="deleteBank1(tr)">删除</vs-button>
                            <vs-button color="primary" v-if="filtering('storeFunds:bankChangeLog')" type="flat" class="flat-btn-table" @click="showBankLog1(tr)">查看银行变更日志</vs-button>
                          </div>
                          <div v-if="tabIndex == 3 && tr.stats == 2">
                            <vs-button color="primary" type="flat" v-if="filtering('storeFunds:recharge')"  class="flat-btn-table" @click="transferAccount1(tr)">再次充值</vs-button>
                            <vs-button color="primary" type="flat" v-if="filtering('storeFunds:rechargeDelete')"  class="flat-btn-table" @click="deleteBank1(tr)">删除</vs-button>
                          </div>
                        </template>
                        <!-- 往来备注 -->
                        <template v-else-if="tdItem.code == 'mark'">
                          <vs-button v-if="tr.showOrder" color="primary" type="flat" class="flat-btn-table" @click.stop="goPageOrderInfo(tr.orderNo)">查看</vs-button>
                          <div v-else>{{tr[tdItem.code]}}</div>
                        </template>
                        <template v-else-if="tdItem.fundFormatter">
                          {{ tr[tdItem.code] | currencyFormat(2,true) }}
                        </template>
                        <div v-else class="flex" :class="tdItem.wareTip ? 'alignCenter' : ''">
                            <div v-if="tdItem.wareTip"><div class="table-ware-tip" :class="tr.wareTipClass"></div></div>
                            <div :class="tr.tdClass">{{ tr[tdItem.code] }}</div>
                        </div>
                      </vs-td>
                    </vs-tr>
                  </tbody>
                </template>
              </vs-table>
            </div>
            <div v-if="tableData.length == 0" class="vs-table--not-data">
              <img src="@/assets/images/commodity-sys/no-data.png" />
              <div class="nodata-text">暂无数据</div>
            </div>
            <!-- <gc-vs-pagination :total="pager.total" v-model="pager.page" :max="7"
                        :max-items="pager.size" :goto="true" class="marTop16"></gc-vs-pagination> -->
            <gc-vs-pagination
              :pager="pager"
              @handleSizeChange="handleSizeChange"
              @handleCurrentChange="handleCurrentChange"
              ></gc-vs-pagination>
          </div>
        </vs-tab>
      </vs-tabs>
      <!-- 账户管理 -->
      <vs-popup class="mainSec" title="账户管理" :active.sync="showAccountDialog">
          <div class="flex flex-align marLeft18">
            <p class="marRight10">主体选择</p>
            <v-select style="flex:1;" v-model="sdMainBodies" :options="sdMainBodiesList" :reduce="opt => opt.id" placeholder="">
              <div slot="no-options">暂无选项</div>
            </v-select>
          </div>
          <div class="marLeft18 marTop18 marBottom40">
            <ul v-if="sdMainBodies" class="account-ul">
              <li class="flex flex-bet marBottom10" v-for="(item, index) in switchAccountList" :key="index">
                <div class="acc-title">{{item.label}}</div>
                <div class="acc-capital" v-if="item.stats == 1" @click="openDialog(accortTr, item.accountType)">调整资金</div>
                <div class=""><span v-if="item.moneyAmount">￥</span>{{item.moneyAmount}}<span>[{{item.switch ? '启动' : '关闭'}}]</span></div>
                <el-switch v-model="item.switch"></el-switch>
              </li>
            </ul>
          </div>
          <div class="deliver-btn flex flexCenter">
              <vs-button color="primary" class="marLeft10 marRight10" type="filled" @click="saveManageAccount">保存</vs-button>
              <vs-button color="primary" class="marLeft10 marRight10" type="filled" @click="showAccountDialog = false">取消</vs-button>
          </div>
      </vs-popup>
      <!-- 资金调整弹窗 -->
      <vs-prompt
          class="cancel-dialog"
          @accept="fundAdjustment()"
          @cancel="cancelAdjustment()"
          @close="cancelAdjustment()"
          title="门店资金调整"
          acceptText="确定调整"
          cancelText="取消"
          :active.sync="showAdjustDialog">
          <div class="con-exemple-prompt">
            <form class="adjust-form">
              <div class="form-item">
                <div class="label">门店名称</div>
                <vs-input disabled="true" name="" v-model="currentuserName" />
              </div>
              <div class="form-item">
                <div class="label">主体选择</div>
                <el-select v-model="currentbodyId" clearable placeholder="请选择">
                  <el-option v-for="item in sdMainBodiesList" :key="item.id" :label="item.label" :value="item.id"></el-option>
                </el-select>
              </div>
              <div class="form-item">
                <div class="label">账户选择</div>
                <el-select v-model="currentaccountType" clearable placeholder="请选择">
                  <el-option v-for="item in switchAccountList" :key="item.accountType" :label="item.label" :value="item.accountType"></el-option>
                </el-select>
              </div>
              <div class="form-item">
                <div class="label">调整类型</div>
                <el-select v-model="currentchangeType" clearable placeholder="请选择">
                  <el-option v-for="item in adjustOptions" :key="item.id" :label="item.label" :value="item.id"></el-option>
                </el-select>
              </div>
              <div class="form-item">
                <div class="label">调整金额</div>
                <vx-input-group>
                  <vs-input type="tel" @change="moneyChange($event,currentmoney)" v-model="currentmoney" maxlength="13"  />
                  <template slot="append">
                    <div class="append-text bg-white">
                      <span>元</span>
                    </div>
                  </template>
                </vx-input-group>
              </div>
              <div class="mount-tip">大于0且保留小数点后两位的数字</div>
              <div class="form-item" style="align-items: flex-start">
                <div class="label">调整备注</div>
                <vs-textarea style="margin-bottom:0;" v-model="currentmark" />
              </div>
            </form>
          </div>
      </vs-prompt>
      <!-- 门店资金转账导入 -->
      <vs-popup
          class="mainSec"
          id="import-dialog"
          @accept="importFund()"
          title="门店资金转账导入"
          :active.sync="showImportDialog">
          <div class="flex flex-align marLeft18">
            <p class="marRight10">主体选择</p>
            <v-select style="flex:1;" v-model="sdMainBodies" :options="sdMainBodiesList" :reduce="opt => opt.id" placeholder="">
              <div slot="no-options">暂无选项</div>
            </v-select>
          </div>
          <div class="upload-account flex flex-align marTop18">
            <div v-for="(item, index) in switchAccountList" :key="index">
              <el-upload
                ref="upload"
                class="upload-demo marTop18"
                :action = "item.action ? item.action : ''"
                :accept="accept"
                :show-file-list = "false"
                :limit="1000"
                :on-success="uploadSuccess"
                :headers="tokenHeader">
                <vs-button color="primary" type="filled" class="browse-btn">{{item.label}}资金导入</vs-button>
              </el-upload>
            </div>
          </div>
          <!-- <div class="import-wrap con-exemple-prompt">
            <div class="import-label">导入文件</div>
            <div class="right-part">
              <el-upload
                      ref="upload"
                      class="upload-demo"
                      :action = "downAction"
                      :accept="accept"
                      :show-file-list = "false"
                      :limit="1000"
                      :on-success="uploadSuccess"
                      :headers="tokenHeader">
                      <vs-button color="primary" type="filled" class="browse-btn">浏览</vs-button>
                    </el-upload>
              <div class="downLoadText pointer" @click="downloadTemplate()">下载文件模板</div>
            </div>
          </div> -->
          <div class="downLoadText pointer marTop18" @click="downloadTemplate()">下载文件模板</div>
          <div class="upload-tip marTop18">导入后自动完成客户资金入账</div>
      </vs-popup>
      <!-- 导入结果 -->
      <vs-prompt
          id="import-result-dialog"
          @accept="showTransferLog()"
          title=""
          acceptText="查看门店转账记录"
          cancelText="取消"
          :active.sync="showResultDialog">
          <div class="con-exemple-prompt">
            <div class="main-content">
              <div class="success-text">{{'成功入账' + successResult + '条'}}</div>
              <div class="fail-text">{{'失败入账' + errorResult + '条'}}</div>
            </div>
          </div>
      </vs-prompt>


      <!-- 新增银行卡数据 -->
      <vs-prompt @accept="saveBank1()" @cancel="cancleAffirm()" :title="addBankTitle1" acceptText="保存" cancelText="取消" :is-valid="validBankParam1" :active.sync="showAddDialog1">
          <div class="con-exemple-prompt">
              <form ref="newBankForm" class="common-pop-form">
                  <template v-for="(item, index) in columns[1]">
                      <template v-if="index > 0 && index < columns[1].length - 4">
                          <div class="form-item" :key="index">
                              <div class="label">{{ item.name }}</div>
                              <vs-input name="item.code" v-model="bankFormData1[item.code]" />
                          </div>
                      </template>
                  </template>
              </form>
          </div>
      </vs-prompt>
      <!-- 查看银行变更日志 -->
      <vs-popup classContent="popup-example" fullscreen :title="bankChangeLogTitle1" :active.sync="showBankLogPop1">
          <commondity-table :columns="bankChangeLogColumns1" :tableData="bankChangeLogData1"></commondity-table>
      </vs-popup>
      <!-- 批量导入 -->
      <vs-popup id="import-dialog" @accept="importFund()" title="门店银行卡导入" acceptText="确认导入" cancelText="取消" :active.sync="showImportDialog1">
          <div class="import-wrap con-exemple-prompt">
              <div class="import-label">导入文件</div>
              <div class="right-part">
                  <el-upload
                      ref="upload"
                      class="upload-demo"
                      :action = "downActions"
                      :accept="accept"
                      :show-file-list = "false"
                      :limit="1000"
                      :on-success="uploadSuccess1"
                      :headers="tokenHeader1"
                  >
                  <vs-button color="primary" type="filled" class="browse-btn">浏览</vs-button>
                  </el-upload>
                  <div class="downLoadText pointer" @click="downloadTemplate(true)">下载文件模板</div>
              </div>
          </div>
      </vs-popup>
      <invoice-detail :typetitle="0" ref="invoiceDetail"></invoice-detail>
  </div>
</template>

<script>
  import GcCmpVsInput from "@/group-cloud/components/vsInput";
  import vSelect from 'vue-select';
  import {FundManageApi, Adjust_Fund_Opts, Concat_Fund_Opts,Customer_Types_Opts} from "@/modules/server-api/subject/subject";
  // import {
  //   Customer_Types_Opts //客户类型
  // } from "@/modules/server-api/commodity-sys/on-shelves";
  import flatPickr from 'vue-flatpickr-component';
  import invoiceDetail from '@/modules/order/orderDetail/invoiceDetail';
  import 'flatpickr/dist/flatpickr.css';
  import {Mandarin} from 'flatpickr/dist/l10n/zh.js';
  import { $busErrorCode, uploadHeader } from "@/modules/commodity-sys/common.js";
  import { downloadExcel, downloadFileTemplate } from "@/utils/downloadExcel.js";
  import { OrderApi } from '@/modules/server-api/commodity-sys/order';
  import { BankApi, Bank_Transfer_Status_Options } from '@/modules/server-api/fund/bank';
  import commondityTable from '@/modules/commodity-sys/components/commodity-table';
  import { bankLogColumns1, bankInfoColumns1, tableColumns } from './columns.js';
  import { validatePosNumber,validateIntNumberSpot, getInputValue, delcommafy } from '@/utils/validateUtil.js';
  import VsTable from "@/modules/order/vsTable/vsTable"
  import VsTd from "@/modules/order/vsTable/vsTd"
  import VsTh from "@/modules/order/vsTable/vsTh"
  import VsTr from "@/modules/order/vsTable/vsTr"
  import {Account_Fund_Opts} from "@/modules/server-api/fund/manage";
  export default {
    data(){
        return{
          tabIndex:0,
          filterText: '',
          flatPickerConfig:{//日期控件配置
            enableTime: true,
            dateFormat: "Y-m-d H:i:S",
            time_24hr: true,
            locale: Mandarin //日期控件中文
          },
          beginTime: '',
          endTime: '',
          accountType:null,//账户类型
          accountTypeOptions:Account_Fund_Opts,
          customerType: [], //门店类型
          customerTypeOptions: Customer_Types_Opts,//门店类型选项
          adjustOptions: Adjust_Fund_Opts,//门店资金调整类型
          concatType: '',
          concatTypeOptions:Concat_Fund_Opts, //门店往来类型
          showAdjustDialog: false,//门店资金调整弹窗
          showImportDialog: false,//门店资金转账导入弹窗
          showResultDialog: false,//资金转账导入结果弹窗
          limitSize: 1024, //限制上传文件大小
          accept:'.excel, .xlsx',
          currentbodyId: '',  //门店资金调整 主体选择
          currentaccountType: '',  //门店资金调整 账户选择
          currentuserName: '',  //门店名称
          currentchangeType: '', //调整类型
          currentmoney: '', //调整金额
          currentmark: '', //调整备注
          currentRowData: {},
          formData:{

          },
          vsTabsList:[
            {
              label:"LIST",
              name:"门店资金列表"
            },
            {
              label:"CONTACT",
              name:"门店银行账号"
            },
            {
              label: 'DETAIL',
              name: '门店收支明细'
            },
            {
              label: 'TRANSFER',
              name: '门店转账充值记录'
            }
          ],
          columns: tableColumns,
          tableData:[],
          tokenHeader: uploadHeader,
          successResult: '',
          errorResult: '',
          pager: {
            page: 1,
            size: 20,
            total: 0
          },
          changeTabIndex: false, //切换页签的时候，即使页码变化也不加载数据
          //filterText1: '',
          moneyStatus:'',
          transferStatus1: '',
          showAddDialog1: false, //新增银行弹窗
          showImportDialog1: false, //导入dialog
          bankChangeLogTitle1: '', //银行变更日志标题
          transferStatuOptions1: Bank_Transfer_Status_Options, //转账状态
          moneyStatusOptions: [
            {
              id: 1, label: "启用"
            },
            {
              id: 0, label: "关闭"
            }
          ],
          addBankTitle1: '',
          showBankLogPop1: false, //查看银行变更日志弹窗
          bankChangeLogColumns1: bankLogColumns1,
          bankChangeLogData1: [],
          bankFormData1: {}, //当前新增或编辑的银行信息
          // beginTime1: '',
          // endTime1: '',
          // columns1: tableColumns1,
          bankInfoColumns1: bankInfoColumns1,
          tokenHeader1: uploadHeader,
          downAction: '',
          downActions:"",
          accountOldId:"",
          accountiIsClose: '',

          tableselected: [],  //选中资金列表
          tableselectedId: [],  //选中资金列表id
          showAccountDialog: false, //账户管理
          sdMainBodies: '', //选中主体
          sdMainBodiesList: [], //主体列表
          switchAccountList: [], //账户列表
          accountUserId: '', //选择账户管理客户id
          bodyId: '', //选中主体id
          accortTr: '', //当前选中客户信息
        }
    },
    components: {
      GcCmpVsInput,vSelect, flatPickr, commondityTable, VsTable, VsTd, VsTh, VsTr, invoiceDetail
    },
    computed:{
      validBankParam1() {
          let saveFlag = true;
          bankInfoColumns1.map(item => {
              let currentItem = this.bankFormData1[item.code];
              if (!currentItem || currentItem == '') {
                  saveFlag = false;
              }
          });
          return saveFlag;
      },
      // tabIndex1() {
      //   return this.tabIndex - 2
      // },
    },
    mounted(){
      this.getTableData();
    },
    methods:{
      //模糊搜索:因页面迁移导致问题 后续需优化
      searchData(){
        if(this.tabIndex % 2 == 0){
          this.getTableData(1);
        }else{
          this.getTableData1(1);
        }
      },
      async getTableData(page){
        this.$vs.loading();
        this.pager.page = page || this.pager.page;
        let pageSize = this.pager.size;
        let param = {
          pageNum: this.pager.page,
          pageSize: pageSize,
          keyword: this.filterText,
          userSort:1,
            accountType:this.accountType,
          userType: this.customerType,//门店类型
          moneyStatus: this.moneyStatus,//账户状态
        }
        this.tableData = [];
        // this.$vs.loading({
        //   container: '#div-with-loading',
        //   scale: 0.6
        // });
        let resp;
        let _this = this;
        if(this.tabIndex == 0){//门店资金列表
          resp = await FundManageApi.getFundList(param);
          console.log(resp);
        }else{//门店资金往来
          param.userSort=1;
          param.changeType = this.concatType;//往来类型
          param.beginTime = this.beginTime;//开始时间
          param.endTime = this.endTime; //结束时间
          resp = await FundManageApi.getFundExpenditure(param);    //todo  good
        }
        if(resp.succ == 1 && resp.code != $busErrorCode){
           this.$vs.loading.close();
          if(this.tabIndex == 0){
            //格式化状态
            let resData = resp.result.list;
            resData.map(item =>{
              item.statsDesc = item.stats == 1 ? '启用' : '关闭';
              item.moneyAmount = parseFloat(item.moneyAmount).toFixed(2);
              _this.tableData.push(item);
            })
          }else{
            resp.result.list.map(item =>{
              item.afterAmount = parseFloat(item.afterAmount).toFixed(2);
              item.changeAmount = parseFloat(item.changeAmount).toFixed(2);
              //格式化备注
              let currRemark = item.mark;
              if(currRemark && currRemark != ''){
                if(currRemark.indexOf("mzFromOrder") > -1){
                  let orderNo = currRemark.split('mzFromOrder:')[1];
                  if(orderNo && orderNo != 'null'){
                    item.mark = '查看';
                    item.showOrder = true;
                    item.orderNo = orderNo;
                  }
                }else{
                  item.showOrder = false;
                }
              }
              _this.tableData.push(item);
            })
          }
          //this.pager.total = Math.ceil(resp.result.totalCount/pageSize);
          this.pager.total = resp.result.totalCount;
          this.$forceUpdate();
        }else{
          this.$vs.loading.close();
          this.$notifyError(resp.result.error || "加载数据失败");
        }
        this.changeTabIndex = false;

      },
      openDialog(row, accountType){
        this.showAdjustDialog = true;
        this.currentRowData = [];
        this.currentRowData = row;
        this.currentuserName = row.userName;
        this.accountUserId = row.userId;
        this.getAccountSec();

        if(accountType || accountType == 0){
          this.$forceUpdate();
        }
      },
      moneyChange(el,val){
        console.log('e',el,val)
        let num = delcommafy(val);
        if(!validateIntNumberSpot(num)){
          this.currentmoney = ''
          this.$notifyError("请输入数字");
          return;
        }
        if (val > 99999999) {
          this.currentmoney = ''
          this.$notifyError("金额操作最大不超过1亿");
          return;
        }
        this.currentmoney = getInputValue(el);
        if(this.currentchangeType == 1) {
          // 判断他剩余充值额度
          let lines = Number(this.currentmoneyAmount) + Number(val);
          // let linesMoney = Number(100000000) - Number(val);
          // console.log('充值总和',lines)
          if (lines > 100000000) {
            this.$notifyError("抱歉，额度不足，请重新输入")
            this.currentmoney = '';
          }

        }
      },
      //门店资金调整
      async fundAdjustment(){
        let { currentbodyId, currentaccountType, currentchangeType, currentmoney, currentmark, accountUserId} = this;
        let saveFlag = false;
        currentmoney = currentmoney.replace(/,/g, "");
        if(currentmoney){
          let reg = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/;
          if(!reg.test(currentmoney)){
            this.$notifyError("请输入整数或者是两位小数");
            this.showAdjustDialog = true;
            return;
          }
        }
        if(currentbodyId.toString() && currentaccountType.toString() && currentchangeType.toString() && currentmoney.toString() || currentmark.toString()){
          saveFlag = true;
        }
        let param = {
          userSort: 1,
          bodyId: currentbodyId,
          accountType: currentaccountType,
          userId: accountUserId,
          changeType: currentchangeType,
          money: currentmoney,
          mark: currentmark
        }
        if(saveFlag){
          let resp = await FundManageApi.adjustFund(param);
          if(resp.succ == 1 && resp.code != $busErrorCode){
            this.$notifySuccess('资金调整成功');
            this.getTableData();
          }else{
            this.currentbodyId = '';
            this.currentaccountType = '';
            this.showAdjustDialog = true;
            this.currentchangeType = 2
            this.$notifyError(resp.error || "资金调整失败");
          }
          this.cancelAdjustment();
        }else{
          this.$notifyError('请将数据填写完整');
          this.showAdjustDialog = true;
        }
      },
      // 取消调整
      cancelAdjustment(){
          this.showAdjustDialog = false;
          this.currentbodyId = '';
          this.currentaccountType = '';
          this.currentchangeType = '';
          this.currentmoney = '';
          this.currentmark = '';
      },
      //关闭资金账户
      closeFundAccount(row, rowIndex, isClose){
        console.log(row, rowIndex, isClose);
        if(this.accountOldId != row.id || this.accountiIsClose != isClose)
        {
          let finalTitle = isClose ? '关闭资金账户提示': '启用资金账户提示';
          let finalText = isClose ? '关闭资金账户后，账户不可再充值和扣款，是否确认关闭？': '是否确认启用';
          this.$confirm(finalText,finalTitle,{
            type:'warning',
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }).then(() => {
            this.doCloseFund(row, rowIndex, isClose);
            this.accountOldId = row.id;
            this.accountiIsClose = isClose;
          }).catch(() => {
          });
        }
      },
      async doCloseFund(row, rowIndex, isClose){
        let param = {};
        param.userId = row.userId;
        param.userSort = 1;
        param.stats = row.stats == 0 ? 1 : 0;
        let statsDesc = param.stats == 1 ? '启用' : '关闭';
        this.$set(this.tableData[rowIndex], 'stats', param.stats);
        this.$set(this.tableData[rowIndex], 'statsDesc', statsDesc);
        let resp = await FundManageApi.closeFundAccount(param);
        if(resp.succ == 1 && resp.code != $busErrorCode){
          let text = param.stats == 1 ? '启用资金账户成功': '关闭资金账户成功';
          this.$notifySuccess(text);

        }else{
          this.$notifyError(resp.result.error || "操作资金账户失败");
        }
      },
      //导入文件后回调函数
      uploadSuccess(response, file, fileList){
        console.log(response);
        if(response.succ == 1 && response.code != $busErrorCode){
           this.showImportDialog = false;
           this.$notifySuccess('导入成功');
           //加载数据
           this.getTableData();
           //成功失败条数
           this.successResult = response.result.succe;
           this.errorResult = response.result.err;
           this.showResultDialog = true;
        }else{
          this.$notifyError(response.error || '导入数据格式错误,请修改后重新上传');
        }
      },
      uploadClick(){
        this.$refs.upload.click();
      },
      //确定导入
      importFund(){
        this.userSort=1;
        this.$notifySuccess('确定导入');
      },
      //查看转账记录
      showTransferLog(){
        this.tabIndex = 3;
        // this.pager.size = 20;
        // this.pager.size = this.successResult;
      },
      //下载
      async download(){
        //组装下载参数
        let param = {
          keyword: this.filterText,
          userType: this.customerType//客户类型
        }
        let url = '';
        let fileName= '门店资金列表';
        if(this.tabIndex == 0){//资金管理下载
          url = '/data-dist/api/money/center/exportMoneyCenterPage';
          param.userSort=1;
        }else if(this.tabIndex == 2){//资金往来下载
          url = '/data-dist/api/money/center/exportMoneyRecord';
          // param.keyword="";
          param.userSort=1;
          param.changeType = this.concatType;//往来类型
          param.beginTime = this.beginTime;//开始时间
          param.endTime = this.endTime; //结束时间
          fileName = '门店收支明细'

        }else if(this.tabIndex == 1){//客户银行账号
          param = {
            pageNum: this.pager.page,
            pageSize: this.pager.size,
            keyword: this.filterText,
            userSortId:1,
            moneyStatus:this.moneyStatus,
          };
          //银行卡
          url = '/data-dist/api/money/center/exportCardInfo';
          fileName = '门店银行账号';
        }else{
           param = {
            pageNum: this.pager.page,
            pageSize: this.pager.size,
            keyword: this.filterText
          };
          url = '/data-dist/api/money/center/cardChargePageExport';
          param.stats = this.transferStatus1; //往来类型
          param.beginTime = this.beginTime; //开始时间
          param.endTime = this.endTime; //结束时间
          param.userSort=1;
          fileName = '门店转账充值记录';
        }
        fileName += '.xlsx';
        downloadExcel(url, param, fileName);
      },
      //下载文件模板
      downloadTemplate(isBank){
        let url = '/data-dist/api/dist/down/template/store_import_charge';
        let name = '门店资金导入模板.xlsx';
        if(isBank){
          url = '/data-dist/api/dist/down/template/store_card_manage_import';
          name = '门店银行卡导入模板.xlsx';
        }
        downloadFileTemplate(url, name);
      },
      //查看资金明细
      async goPageOrderInfo(orderNo){
        let resp = await OrderApi.getOrderGoods({orderNo: orderNo});
        if(resp.succ == 1 && resp.code != $busErrorCode){
          //获取订单信息
          // sessionStorage.setItem('detail', JSON.stringify(resp.result));
          // this.$router.push({ path: '/modules/order/orderDetail' }).catch(() => {});
          //获取订单信息
          sessionStorage.setItem('detail', JSON.stringify(resp.result));
          sessionStorage.setItem('editFlag', false);
           this.$refs.invoiceDetail.getData()
        }else{
          this.$notifyError(resp.error || "获取详细信息失败");
        }
      },
       //获取银行列表信息
      async getTableData1(page) {
         this.$vs.loading();
          this.pager.page = page || this.pager.page;
          let pageSize = this.pager.size;
          let param = {
              pageNum: this.pager.page,
              clientId:this.clientId,
              pageSize: pageSize,
              keyword: this.filterText,
              userType: this.customerType,//客户类型
              userSortId:1,
          };
          let resp;
          this.tableData = [];
          if (this.tabIndex == 1) {
              //银行卡列表
              resp = await FundManageApi.getFundSearch(param);
              console.log(resp);
          } else {
              //银行转账记录
              let params = {
                    clientId:this.clientId,
                    pageNum: this.pager.page,
                    pageSize: pageSize,
                    keyword: this.filterText,
                    userType: this.customerType,//客户类型
                    userSort:1,
                    stats:this.transferStatus1,
                    beginTime:this.beginTime,
                    endTime:this.endTime
                };
              resp = await FundManageApi.getFundRecharge(params);
          }
          let _this = this;

          if (resp.succ == 1 && resp.code != $busErrorCode) {
             this.$vs.loading.close();
              //格式化状态
              resp.result.list.map(item => {
                  if (_this.tabIndex == 3) {
                      item.statsDesc = item.stats == 1 ? '已完成充值' : '未完成充值';
                      item.wareTipClass = item.stats == 1 ? 'add' : 'delete';
                  }
                  _this.tableData.push(item);
              });
          } else {
              this.$vs.loading.close();
              this.$notifyError(resp.error || '加载数据失败');
          }
          // this.pager.total = Math.ceil(resp.result.totalCount / pageSize);
          this.pager.total = resp.result.totalCount;
          this.changeTabIndex = false;
          this.pager.size=20;
          this.$forceUpdate();
      },
      //编辑
      editBank1(row) {
          if (row) {
              this.addBankTitle1 = '编辑';
              this.bankFormData1 = row;
          } else {
              this.addBankTitle1 = '新增';
              let newForm = {};
              this.bankInfoColumns1.map(item => {
                  newForm[item.code] = '';
              });
              this.bankFormData1 = { ...newForm };
          }
          this.showAddDialog1 = true;
      },
      //保存银行
      async saveBank1() {
          //校验信息是否为空
          if (this.validBankParam1) {
              let param = this.bankFormData1;
              param.userSort = 1;
              let resp = await BankApi.saveBankInfo(param);
              if (resp.succ == 1 && resp.code != $busErrorCode) {
                  this.$notifySuccess('保存成功');
                  this.getTableData1();
              } else {
                  this.$notifyError(resp.error || '保存失败');
              }
          }
      },
      cancel(){
        this.showAddDialog1 = false;
      },
            // 确认取消
      cancleAffirm(){
          this.$vs.dialog({
            type: "confirm",
            title: `请确认`,
            text: `是否确认取消`,
            acceptText: "确认",
            cancelText: "取消",
            accept: () => {
            this.cancel();
           },
          });
      },
      //删除银行
      deleteBank1(row) {
          let titleTip = this.tabIndex == 1 ? '是否确认删除银行卡？' : '是否确认删除充值记录？';
          this.$vs.dialog({
              type: 'confirm',
              color: 'danger',
              title: '操作提示',
              text: titleTip,
              acceptText: '确认',
              cancelText: '取消',
              accept: () => {
                  this.doDelete1(row);
              }
          });
      },
      async doDelete1(row) {
          let res;
          if (this.tabIndex == 1) {
              //删除银行卡
              res = await BankApi.deleteBankInfo({ id: row.id });
              console.log(res);
          } else {
              //删除转账记录
              res = await BankApi.deleteBankTransferInfo({ id: row.id });
          }
          if (res.succ == 1) {
              this.$notifySuccess('删除成功');
              this.getTableData1(1);
          } else {
              this.$notifyError(res.error || '删除失败');
          }
      },
      //查看银行日志
      async showBankLog1(row) {
          let res = await BankApi.showBankLog({ userName: row.userName });
          if (res.succ == 1 && res.code != $busErrorCode) {
              this.bankChangeLogTitle1 = row.userName + '-银行变更日志';
              this.bankChangeLogData1 = [];
              res.result &&
                  res.result.map(item => {
                      switch (item.changeType) {
                          case 1:
                              item.changeTypeDesc = '添加';
                              item.wareTipClass = 'add';
                              break;
                          case 2:
                              item.changeTypeDesc = '更新';
                              item.wareTipClass = 'update';
                              break;
                          case 3:
                              item.changeTypeDesc = '删除';
                              item.wareTipClass = 'delete';
                              break;
                      }
                      this.bankChangeLogData1.push(item);
                  });
              this.showBankLogPop1 = true;
          } else {
              this.$notifyError(res.error || '加载变更日志失败');
          }
      },
      //批量充值
      downrechargeEvent(){
          let that=this;
          that.showImportDialog=true;
          that.getAccountSec();
          console.log(that.downAction);
      },
      //批量导入
      downrechargeBatch(){
          let that=this;
          that.showImportDialog1=true;
          let userSort = 1;   //1 门店 0 客户
          that.downActions = `/data-dist/api/money/center/importBankCard/${userSort}`
          console.log(that.downActions);
      },
      //转账记录
      async transferAccount1(row) {
          this.$vs.dialog({
              type: 'confirm',
              color: 'primary',
              title: '操作提示',
              text: '您确认再次充值吗？',
              acceptText: '确认',
              cancelText: '取消',
              accept: () => {
                  this.doTransferAccount1(row);
              }
          });
      },
      async doTransferAccount1(row) {
          let resp = await BankApi.bankTransfer({ ids: row.id });
          if (resp.succ == 1 && resp.code != $busErrorCode) {
              this.$notifySuccess('充值成功');
              this.getTableData1();
          } else if (resp.succ == 0 && resp.code != $busErrorCode) {
              this.$notifyError('充值失败');
          } else {
              this.$notifyError(resp.error || '充值失败');
          }
      },
      //导入文件
      uploadSuccess1(response) {
          if (response.succ == 1 && response.code != $busErrorCode) {
              this.showImportDialog1 = false;
              this.$notifySuccess('导入成功');
              this.getTableData1();
          } else {
              this.$notifyError(response.error || '导入数据格式错误,请修改后重新上传');
          }
      },
      //校验
      validateNumber(val){
       if(!validatePosNumber(val)){
         this.currentmoney = isNaN(val) ? '' : this.currentmoney;
         this.$notifyError("请输入正数并且最多2位小数的数字");
       }
      },
      handleSizeChange(val){
        this.pager.size = val;
        if(!this.changeTabIndex){//切换页签的时候不重复加载数据
          this.tableData = [];
         if(this.tabIndex % 2 == 0){
            this.getTableData();
          }else{
            this.getTableData1();
          }
        }
      },
      handleCurrentChange(val){
        this.pager.page = val;
        if(!this.changeTabIndex){//切换页签的时候不重复加载数据
          this.tableData = [];
         if(this.tabIndex % 2 == 0){
            this.getTableData();
          }else{
            this.getTableData1();
          }
        }
      },
      //账户管理
      openAccount(tr) {
        let that = this;
        that.showAccountDialog = true;
        that.accortTr = tr;
        that.accountUserId = tr.userId;
        that.getAccountSec()
      },
      // 获取账户管理信息
      async getAccountSec(){
        let that = this,
            params = {};
        params = {
          userId: that.accountUserId,
          bodyId: that.bodyId,
          userSort: 1,
        }
        let resp = await FundManageApi.editManageAccount(params);
        if(resp.code == 0 && resp.succ == 1){
          let result = resp.result;
          result.sdMainBodies.map(item => {
            item.label = item.name;
            return item;
          })
          result.accounts.map(item => {
            item.label = item.accountType == 0 ? '预付款账户' : (item.accountType == 1 ? '达量奖励账户' : '门店补贴账户');
            item.switch = item.stats == 1 ? true : false;
            item.moneyAmount = item.moneyAmount ? item.moneyAmount.toFixed(2) : '';
            if(that.bodyId){
              let userSort = 1;   //1 门店 0 客户
              item.action = `/data-dist/api/money/center/chargeByCard/${that.bodyId}/${item.accountType}/${userSort}`;   //批量充值
            }
          })
          if(!that.bodyId){
            that.sdMainBodies = result.sdMainBodies[0].id;
          }
          that.sdMainBodiesList = result.sdMainBodies;
          that.switchAccountList = result.accounts;
          // console.log(that.sdMainBodiesList);
        }
      },
      //保存账户管理信息
      async saveManageAccount() {
        let that = this,
            accountsList = {};
        that.switchAccountList.map(item => {
          accountsList.userId = item.userId;
          accountsList.bodyId = item.bodyId;
          accountsList.stats = item.switch ? 1 : 0;
          accountsList.userSort = 1;
          return accountsList;
        })
        console.log(accountsList)
        let resp = await FundManageApi.changeStats(accountsList);
        if(resp.code == 0 && resp.succ == 1){
          that.showAccountDialog = false;
          this.getTableData(1);
          that.$notifySuccess('设置成功');
        }else{
          that.$notifyError(resp.error);
        }

      },
    },
    watch:{
      tabIndex(){
        //清空数据
        this.concatType = '';
        this.customerType = [];
        this.filterText = '';
        this.beginTime = '';
        this.endTime = '';
        this.tableData = [];
        this.accountType = '';
        this.changeTabIndex = true;
        this.tableselected = [];
        if(this.tabIndex == 0 || this.tabIndex ==2){
          this.getTableData(1);
        }else{
          this.getTableData1(1);
        }

      } ,
      tableselected(array) {
        let that = this,
            usersId = [];
        array.map(ele => {
            usersId.push(ele.userId);
        })
        that.tableselectedId = usersId;
      },
      sdMainBodies(val){
        // console.log(val)
        let that = this;
        that.bodyId = val;
        that.getAccountSec();
      },
      // "pager.page"(){
      //   if(!this.changeTabIndex){//切换页签的时候不重复加载数据
      //     this.tableData = [];
      //    if(this.tabIndex % 2 == 0){
      //       this.getTableData();
      //     }else{
      //       this.getTableData1();
      //     }
      //   }
      //},
      currentbodyId(val){
        this.currentbodyId = val;
        this.getAccountSec()
        this.currentaccountType = '';
      },
      currentmoney(){
        this.currentmoney < 0 ? this.currentmoney='' : '';
      }
    },
  }
</script>

<style lang="scss" scoped>
@import "@/modules/commodity-sys/commodity.scss";
.flex-bet{
    justify-content: space-between;
}
.flex-align{
  align-items: center;
}
.el-select{
  width: 296px;
}
.mainSec /deep/ .vs-popup{
  width: 500px !important;
  min-height: 300px;
  .vs-popup--content{
    min-height: 264px;
  }
}
.account-ul{
  min-height: 85px;
  li{
    .acc-title{
      width: 35%;
    }
    .acc-capital{
      color: #409EFF;
      cursor: pointer;
    }
  }
}
.upload-account{
  flex-direction: column;
  min-height:180px;
}
  .filterWrap{
    align-items: center;
    justify-content: space-between;
    .filterInput{
      text-align: left;
      width: 152px;
    }
  }
    /deep/ .vs-textarea {
    resize:none !important;
    min-height: 135px;
  }
  .marLeft10{
    margin-left: 10px;
  }
  .adjust-form{
    padding: 14px;
    .form-item{
      @include flex-mixin(row, center, flex-start);
      &:not(:first-child){
        margin-top: 20px;
      }
      .label{
        width: 58px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #5E5873;
        margin-right: 16px;
      }
      .vs-con-input-label, .v-select{
        width: 296px;
      }
      .vs-con-textarea{
        width: 450px;
        height: 135px;
        margin-bottom: 80px;
      }
      .vx-input-group{
        .vs-con-input-label{
          width: 254px;
        }
        .bg-white {
          background-color: #fff;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #BABFC7;
        }
        .vx-input-group-append{
          border: 1px solid rgba(0, 0, 0, 0.2);
          border-left: 0;
        }
      }
    }
    .mount-tip{
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #AAAABC;
      margin-left: 72px;
      margin-top: 6px;
    }
  }

  #import-result-dialog{
    /deep/ .vs-dialog{
      width: 415px;
    }
    .main-content{
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      margin-bottom: 40px;
      text-align: center;
      .success-text{
        color: #272727;
      }
      .fail-text{
        color: #FF433D;
        margin-top: 8px;
      }
    }
  }
 .vs-dialog-primary .vs-dialog .vs-dialog-header{
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #14151B !important;
  }
  /deep/ .vs-dialog footer{
    justify-content: center;
    button{
      width: 126px;
    }
    .vs-dialog-cancel-button{
      border: 1px solid rgba(var(--vs-primary), 1) !important;
    }
  }
  #import-result-dialog /deep/ .vs-dialog footer{
    button{
      width: 155px;
    }
  }
   /deep/ .vs-dialog header .dialog-title{
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #14151B;
    }
  .customerType   /deep/ .el-input__inner {
      border: 1px solid rgba(60, 60, 60, 0.26) !important;
      height: 38px;
    }
    .customerType   /deep/ input::-webkit-input-placeholder {
       color: rgba(0, 0, 0, 0.4);
        font-size: 12px;
    }
    .btn-box {
      position: relative;
    }
    @media (max-width: 1550px){
      .btn-content {
        position: absolute;
        top: 80px;
        right: 10px;
      }
      .mb-60 {
        margin-bottom: 60px;
      }
    }
</style>
<style lang="scss" >
.cancel-dialog{
  z-index: 1510;
}
</style>
